export function getCsrfToken(): string | null {
  const tokenEl = document.querySelector("meta[name=csrf-token]");
  if (tokenEl == null) {
    console.error("csrf token element not found");
    return null;
  }

  return tokenEl.getAttribute("content");
}
